import lrImgSelect from './_src/lrImgSelect.vue'

lrImgSelect.install = function(Vue) {
  Vue.component(lrImgSelect.name, lrImgSelect)
}

export default lrImgSelect